<script lang="ts">
  import type { IChild, IRegistration } from '../api/entities';
  import { getFieldFormData } from '../utils';

  export let registration: IRegistration;
  export let validate: () => void;
  export let cancel: () => void;
  let nbChildren = registration?.children.length || 1;

  const handleChildren = (children: number) => {
    nbChildren = children;
    const currentNbChildren = registration?.children?.length || 0;
    if (nbChildren >= currentNbChildren) {
      registration.children = registration.children.concat(Array(nbChildren - currentNbChildren).fill(undefined).map(() => ({ age: 5 })));
    }
    else {
      registration.children = registration.children.slice(0, nbChildren);
    }
  }

let fieldsFormData = {
  name: getFieldFormData((value: string) => !!value),
  phone: getFieldFormData((value: string) => !!value.match(/^[0-9\.\-\s]{10,}$/)),
  children: getFieldFormData((value: IChild[]) => registration.nbAdults > 0 || value.every(c => c.age > 6), true),
};

const checkField = (fieldName: string) => {
  const fieldData = fieldsFormData[fieldName];
  fieldData.hasBeenTouched = true;
  fieldData.isValid = fieldsFormData[fieldName].check(registration[fieldName]);
  fieldsFormData = fieldsFormData;
};

</script>

<style lang="scss">
  @import "../styles/bulma.override";

	.session-button {
		height: unset !important;
	}

  @include mobile {
    .p-5 {
      padding: 0 !important;
    }
  }
</style>


<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="name">Nom</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          class="input"
          type="text"
          bind:value={registration.name}
          on:blur={() => checkField('name')}
          class:is-danger={fieldsFormData.name.isError}
        >
      </div>
      {#if fieldsFormData.name.isError}
      <p class="help is-danger has-text-left">Le nom est obligatoire</p>
      {/if}
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="phone">Téléphone</label>
  </div>
  <div class="field-body">
    <div class="field">
      <div class="control">
        <input
          class="input"
          type="text"
          bind:value={registration.phone}
          on:blur={() => checkField('phone')}
          class:is-danger={fieldsFormData.phone.isError}
        >
      </div>
      {#if fieldsFormData.phone.isError}
      <p class="help is-danger has-text-left">Le numéro de téléphone doit être bien renseigné</p>
      {/if}
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="nbAdults">Nombre d'adultes</label>
  </div>
  <div class="field-body">
    <div class="field buttons">
      {#each [0, 1, 2] as nb}
        <button
          on:click={() => { registration.nbAdults = nb; checkField('children'); }}
          class="button is-primary"
          class:is-outlined={registration.nbAdults !== nb}
        >
          {nb}
        </button>
      {/each}
    </div>
  </div>
</div>

<div class="field is-horizontal">
  <div class="field-label is-normal">
    <label for="nbChildren">Nombre d'enfants</label>
  </div>
  <div class="field-body">
    <div class="field buttons">
      {#each [1, 2, 3, 4, 5, 6] as nb}
        <button
          on:click={() => { handleChildren(nb); checkField('children'); }}
          class="button is-primary"
          class:is-outlined={nbChildren !== nb}
        >
          {nb}
        </button>
      {/each}
    </div>
  </div>
</div>

{#each registration.children as enfant, idx}
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label for={`ageChild${idx}`}>{`Age de l'enfant ${registration.children.length > 1 ? idx + 1 : ''}`}</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            class="input"
            class:is-danger={enfant.age < 7 && fieldsFormData.children.isError}
            type="text"
            bind:value={enfant.age}
            on:blur={() => checkField('children')}
          />
        </div>
      </div>
    </div>
  </div>    
{/each}

{#if fieldsFormData.children.isError}
<div class="field is-horizontal">
  <div class="field-label is-normal"></div>
  <div class="field-body">
    <p class="help is-danger has-text-left">Les enfants de moins de 7 ans ne peuvent venir que s'il y a un adulte avec eux.</p>
  </div>
</div>
{/if}
  
<button
  class="button is-primary is-medium"
  on:click={validate}
  disabled={Object.entries(fieldsFormData).some(([, data]) => !data.isValid)}
>Valider</button>
<button class="button is-outlined is-medium" on:click={cancel}>Annuler</button>
